import styles from './services-list.module.scss'
export default () => {
  return {
    initial: {
      query: '',
      advertising_type_ids: [],
    },
    configuration: {
      advertising_type_ids: {
        subbutton: {
          isVisible: false,
        },
        icon: null,
        label: 'services::networks_list.filters.dropdown.items.advertising_type.label',
        type: 'checkbox selector',
        typeAsButtonControl: 'checkbox selector',
        optionLabelPrefix: '',
        options: [],
        order: 2,
        className: styles['filter-panel__advertising-type'],
      },
      query: {
        subbutton: false,
        label: 'services::networks_list.filters.input.label',
        placeholder: 'services::networks_list.filters.input.label',
        order: 1,
        type: 'input',
        className: styles['filter-panel__query'],
      },
    },
  }
}
